<div class="main-content rep-bulk-enable-page">
	<div class="container-fluid">
		<div class="row">
			<div class="col-12">
				<div class="card">
					<div class="card-header card-header-{{ color }}-6">
						<h4 class="card-title">
							<i class="material-icons rep-bulk-back" (click)="back()">arrow_back</i>
							Bulk Enable Customer Email
						</h4>
						<p class="card-category text-right mb-0">
							Turn on auto invoice and statement email for a rep&rsquo;s customer book
						</p>
					</div>

					<div class="card-body">
						<section class="rep-bulk-filters" aria-label="Salesperson selection">
							<div class="row g-3 align-items-end">
								<div class="col-md-4" *ngIf="!isSalesman">
									<mat-form-field appearance="outline" class="w-100">
										<mat-label>Salesperson</mat-label>
										<mat-select [formControl]="salesmanCtrl">
											<mat-option *ngFor="let sp of salespeople" [value]="sp.salesmancode">
												{{ sp.salesmancode }} — {{ sp.salesmanname }}
											</mat-option>
										</mat-select>
									</mat-form-field>
								</div>
								<div class="col-md-4" *ngIf="isSalesman">
									<div class="rep-bulk-salesman-readonly">
										<span class="rep-bulk-label">Your book</span>
										<strong>{{ salesmanLabel || sessionSalesmanCode }}</strong>
									</div>
								</div>
								<div class="col-md-8 rep-bulk-filter-actions">
									<button
										mat-raised-button
										color="primary"
										type="button"
										(click)="loadPreview()"
										[disabled]="loadingPreview || applying || (!isSalesman && !salesmanCtrl.value)"
									>
										<mat-icon>refresh</mat-icon>
										Load preview
									</button>
									<mat-spinner *ngIf="loadingPreview" diameter="28" class="rep-bulk-inline-spinner"></mat-spinner>
								</div>
							</div>
							<p class="text-danger mb-0" *ngIf="previewError">{{ previewError }}</p>
						</section>

						<section class="rep-bulk-counts" *ngIf="counts" aria-label="Preview counts">
							<h5 class="rep-bulk-section-title">Preview — {{ salesmanLabel || salesmancode }}</h5>
							<div class="row g-2">
								<div class="col-6 col-md-4 col-lg-3" *ngFor="let card of countCards">
									<div class="rep-bulk-count-card">
										<div class="rep-bulk-count-value">{{ counts[card.key] ?? 0 }}</div>
										<div class="rep-bulk-count-label">{{ card.label }}</div>
									</div>
								</div>
							</div>
						</section>

						<section class="rep-bulk-samples" *ngIf="samples?.length" aria-label="Sample customers">
							<h5 class="rep-bulk-section-title">Sample customers (up to 10)</h5>
							<div class="table-responsive">
								<table class="table table-sm table-striped rep-bulk-table">
									<thead>
										<tr>
											<th>Customer #</th>
											<th>Name</th>
											<th>Auto invoice</th>
											<th>Email statement</th>
											<th>Invoice email</th>
											<th>Status</th>
										</tr>
									</thead>
									<tbody>
										<tr *ngFor="let row of samples">
											<td>
												<a href="javascript:void(0)" (click)="openCustomer(row.debtorno)">{{ row.debtorno }}</a>
											</td>
											<td>{{ row.name }}</td>
											<td>{{ row.ediinvoices ? 'Yes' : 'No' }}</td>
											<td>{{ row.emailstatement ? 'Yes' : 'No' }}</td>
											<td>{{ row.invoice_email || '—' }}</td>
											<td>{{ emailStatusLabel(row.email_status) }}</td>
										</tr>
									</tbody>
								</table>
							</div>
						</section>

						<section class="rep-bulk-actions" *ngIf="counts" aria-label="Bulk actions">
							<h5 class="rep-bulk-section-title">Actions</h5>
							<div class="rep-bulk-action-checks">
								<mat-checkbox [(ngModel)]="actionEdiInvoices">Enable auto email invoices</mat-checkbox>
								<mat-checkbox [(ngModel)]="actionEmailStatement">Enable email statements</mat-checkbox>
								<mat-checkbox [(ngModel)]="actionSyncContacts">Sync INVOICE / STATEMENT contacts</mat-checkbox>
							</div>
							<p class="text-muted rep-bulk-hint">
								Customers without a valid email (or marked noemail) are skipped. Auto invoice is not enabled without a valid address.
							</p>
							<div class="rep-bulk-action-buttons">
								<button
									mat-stroked-button
									color="primary"
									type="button"
									(click)="runDryRun()"
									[disabled]="!canRunActions"
								>
									<mat-icon>visibility</mat-icon>
									Dry run
								</button>
								<button
									mat-raised-button
									color="accent"
									type="button"
									(click)="confirmApply()"
									[disabled]="!canRunActions"
								>
									<mat-icon>done_all</mat-icon>
									Apply to rep book
								</button>
								<mat-spinner *ngIf="applying" diameter="28" class="rep-bulk-inline-spinner"></mat-spinner>
							</div>
							<p class="text-danger mb-0" *ngIf="applyError">{{ applyError }}</p>
						</section>

						<section class="rep-bulk-result" *ngIf="applyResult" aria-label="Apply result">
							<h5 class="rep-bulk-section-title">
								{{ applyResult.dryRun ? 'Dry run result' : 'Apply result' }}
							</h5>
							<p>
								<strong>{{ applyResult.updated }}</strong> updated /
								would update &middot;
								<strong>{{ applyResult.skipped }}</strong> skipped
							</p>
							<div class="table-responsive" *ngIf="applyResult.details?.length">
								<table class="table table-sm table-bordered rep-bulk-table">
									<thead>
										<tr>
											<th>Customer #</th>
											<th>Status</th>
											<th>Email(s)</th>
											<th>Reason</th>
										</tr>
									</thead>
									<tbody>
										<tr *ngFor="let d of applyResult.details">
											<td>{{ d.debtorno }}</td>
											<td>{{ d.status }}</td>
											<td>{{ d.emails || '—' }}</td>
											<td>{{ d.reason || '—' }}</td>
										</tr>
									</tbody>
								</table>
							</div>
						</section>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
